<template>
  <li class="accordion" :class="{ open: isVisible }" v-if="description">
    <div class="accordion-item" @click="toggle()">
      <i :class="'icon-' + icon"></i>
      {{ title }}
      <div class="arrow">
        <i class="icon-fleche_collapse"></i>
      </div>
    </div>
    <div v-show="isVisible">
      <v-runtime-template :template="descriptionWithMedia" class="data"></v-runtime-template>
    </div>
  </li>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import VRuntimeTemplate from 'v-runtime-template';
import Media from 'directives/Media';

export default {
  props: {
    icon: String,
    title: String,
    description: String,
  },
  directives: {
    Media,
  },
  components: {
    VRuntimeTemplate,
  },
  mounted() {
    if ((this.description && this.description.includes('highlight')) || this.isOpened) {
      this.isVisible = true;
    }
  },
  computed: {
    ...mapState('artworks', ['accordions']),
    isOpened() {
      return this.accordions.indexOf(this.title) >= 0;
    },
    descriptionWithMedia() {
      return `<div>${this.description.replace(/media=/gi, 'v-media media=')}</div>`;
    },
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    ...mapActions('artworks', ['addAccordion', 'removeAccordion']),
    toggle() {
      this.isVisible ^= true;
      if (this.isVisible) {
        this.addAccordion(this.title);
      } else {
        this.removeAccordion(this.title);
      }
    },
  },
};
</script>

<style lang="less">
.accordion {
  padding: 0 !important;

  &.open {
    .arrow {
      -webkit-transform: rotate(90deg); /* Chrome, Safari, Opera */
      transform: rotate(90deg);
    }

    i {
      color: @accordion-open-icon-color;
    }

    .data {
      display: block;
      overflow: hidden;
    }
  }
  .data {
    display: none;
    &.biblio {
      white-space: pre-wrap;
      margin-left: 55px;
      padding-right: 5px;
    }

    ul {
      margin-left: 55px;
      padding: 0 0 5px 0;
      list-style: circle #f00;
      list-style-type: disc;

      li {
        padding: 5px 5px 0;

        a {
          color: @accordion-data-link-color;
        }
      }
    }
  }

  ul {
    list-style: square;

    li {
      white-space: pre-line;
    }
  }
}

.accordion-item {
  padding: 10px;
  position: relative;
  background-position: 10px 10px;
  background-repeat: no-repeat;
  cursor: pointer;

  &.expositions:hover i {
    color: @accordion-open-icon-hover-color;
  }

  &.bibliography:hover i {
    color: @accordion-open-icon-hover-color;
  }

  .arrow {
    position: absolute;
    top: 12px;
    right: 15px;
    width: 8px;
    height: 8px;
  }
}

a[rel] {
  display: inline-block;
  padding: 5px;
  line-height: 20px;
  width: 100%;

  &:hover {
    background-color: @rich-link-hover-color;

    &::after {
      color: initial;
    }
  }
  &::after {
    &:extend([class^='icon-']);
    line-height: 20px !important;
    color: @rich-link-icon-color;
    float: right;
    clear: right;
  }
}
</style>
